import { endBattle } from "@/battle/BattleController";
import { closeTraining } from "@/training/TrainingController";
import { saveGame } from "./save";
import { calculatorOpen, dialog, panel, screen } from "./store";

/**
 * Save the current hero and go back to the start screen (the World scene reacts to `screen`).
 * Any open overlay is closed first so the next hero starts clean.
 */
export function returnToTitle(): void {
  if (screen.value !== "world") return;
  saveGame();
  endBattle();
  closeTraining();
  dialog.value = null;
  panel.value = null;
  calculatorOpen.value = false;
  screen.value = "title";
}
